module.exports = __webpack_public_path__ + "img/img8.20c2b033.png";